// any[] (not unknown[]) so callers' typed handlers satisfy the param via contravariance.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Handler = (...args: any[]) => void;

const listeners = new Map<string, Handler[]>();

export default {
  $on(event: string, handler: Handler): void {
    const handlers = listeners.get(event);
    if (handlers) {
      handlers.push(handler);
    } else {
      listeners.set(event, [handler]);
    }
  },

  $off(event: string, handler?: Handler): void {
    if (!handler) {
      listeners.delete(event);
      return;
    }
    const remaining = (listeners.get(event) ?? []).filter((h) => h !== handler);
    if (remaining.length > 0) {
      listeners.set(event, remaining);
    } else {
      listeners.delete(event);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $emit(event: string, ...args: any[]): void {
    const handlers = listeners.get(event);
    if (!handlers) return;
    for (const handler of [...handlers]) {
      handler(...args);
    }
  },
};
